import React, { useState, useEffect } from "react";
import {
  Accordion,
  ButtonGroup,
  Button,
  Card,
  Modal,
  Tabs,
  Tab,
} from "react-bootstrap";
import {
  DATE_FORMATS,
  SOCIAL_SOURCES,
  TAB,
  VERTICALS,
} from "../../../constants/app-constant";
import {
  formatDate,
  getDateFormat,
  getSocialApiDateFormat,
  groupBy,
} from "../../../utility/common-methods";
import {
  NoFeedIcon,
  ModalCloseIcon,
  SocialForumIcon,
  TwitterIcon,
  TwitterWBIcon,
} from "../../Icons/icons.component";
import Loader from "../../Shared/Loader";
import SingleTwitterFeed from "./SingleTwitterFeed";
import { httpGet } from "../../../utility/requestHelper";
import { unifiedEnvConfig } from "../../../constants/api-endpoint";
import Sticky from "react-sticky-el";
import ShareArticle from "../../Shared/ShareArticle";

const defaultActiveKeys = { twitter: 1 };
export const TwitterFeedsModal = function ({
  show,
  selectedTabKey,
  onCancel,
  cancelButtonText,
  clientId,
  handleVerticalClick,
  selectedVertical,
  tabData,
  startRange,
  endRange,
  selectedFilter,
  topicId,
}) {
  const { TWITTER_INSIGHTS } = VERTICALS;
  const [tabKey, setTabKey] = useState(selectedTabKey);
  const [tabFeeds, setTabFeeds] = useState([]);
  const [loaderState, setLoaderState] = useState(false);
  const [feedLoader, setFeedLoader] = useState(false);
  const [allSocialFeeds, setAllSocialFeeds] = useState([]);
  const [activeAccordian, setActiveAccordian] = useState();
  const [activeAccordianKey, setActiveAccordianKey] = useState("1");
  const [currentPage, setCurrentPage] = useState(1);
  const [hasData, setHasData] = useState(true);
  const [activeKeys, setActiveKeys] = useState(defaultActiveKeys);
  const [ungroupedData, setUngroupedData] = useState([]);
  const [selectedFeeds, setSelectedFeeds] = useState([]);
  const [selectedFeedGroup, setSelectedFeedGroup] = useState({});
  const perPage = 20;
  useEffect(() => {
    if (show) {
      getDailyFeeds();
    }
  }, [show, tabData]);

  const isEntityGroupSelected = (tName) => {
    return (
      selectedFeedGroup &&
      typeof selectedFeedGroup == "object" &&
      Object.keys(selectedFeedGroup).indexOf(tName) !== -1
    );
  };
  /** selectedEntityGroup is an state object used to keep track of selected topics.
   * It contains array of {topicName: topicFeeds} type entry. Which is added when selected, and
   * removed when deselected.
   */
  const handleTopicSelect = (tData) => {
    try {
      const { name, feeds } = tData;
      if (isEntityGroupSelected(name)) {
        const tempSFG = { ...selectedFeedGroup };
        let tempArr = [...selectedFeeds];
        feeds.forEach((element) => {
          tempArr = tempArr.filter((n) => {
            if (n.id !== element.id) return n;
          });
        });
        setSelectedFeeds(tempArr);
        delete tempSFG[name];
        setSelectedFeedGroup(tempSFG);
      } else {
        setSelectedFeedGroup({
          ...selectedFeedGroup,
          ...{
            [name]: feeds,
          },
        });
        setSelectedFeeds([...selectedFeeds, ...feeds]);
      }
    } catch (e) {}
  };
  /** Handles selection of single feed and its side effects.
   * Side Effects -if entire topic is selected and any of its single feed is deselected,
   * the topic group should be deleted from selectedFeedsGroup state object.
   * and only remaining feeds should be marked as selected.
   */
  const handleSingleFeedSelect = (feed) => {
    try {
      const selectedElmList = selectedFeeds.filter((n) => n.id == feed.id);
      const selectedElm = selectedElmList && selectedElmList[0];
      if (selectedElm) {
        const { entityName } = feed;
        if (isEntityGroupSelected(entityName)) {
          const tempSFG = { ...selectedFeedGroup };
          delete tempSFG[entityName];
          setSelectedFeedGroup(tempSFG);
        }
        let listWithoutCurrentFeed = selectedFeeds.filter(
          (n) => n.id != selectedElm.id
        );
        setSelectedFeeds(listWithoutCurrentFeed);
      } else {
        setSelectedFeeds([...selectedFeeds, feed]);
      }
    } catch (e) {}
  };

  const formatAndSetData = ({
    feed_list = [],
    entity_list = [],
    pagination = false,
    newFeeds = [],
    incrementPageCount = false,
  }) => {
    // formatting feeds data for the accordian.
    const entity_ids = getEntityIdList(entity_list);
    let newList = [];
    feed_list.forEach((feedObj) => {
      entity_ids.forEach((f) => {
        if (
          (feedObj.topic && feedObj.topic.id == f) ||
          (feedObj && feedObj.id == f)
        ) {
          const topic = feedObj.topic ? feedObj.topic : feedObj;
          topic.feed_count = feedObj.total ? feedObj.total : feedObj.feed_count;
          if (!pagination) {
            // initiating page count
            topic["page"] = 1;
            topic["pages"] = perPage;
            topic["feeds"] = feedObj.feeds;
          } else {
            topic["feeds"] = [...feedObj.feeds, ...newFeeds];
          }
          if (incrementPageCount) {
            topic["page"] = topic["page"] + 1;
            topic["pages"] = perPage;
          }

          newList.push(topic);
        }
      });
    });
    return newList;
  };

  const getEntityIdList = (array = []) => {
    return array.map((i) => (i.topic ? i.topic.id : i));
  };

  const getDailyFeeds = (verticalId = selectedVertical) => {
    setLoaderState(false);
    setLoaderState(true);
    httpGet(
      `${unifiedEnvConfig.SOCIAL_DAILY_FEED_COUNT_LIST.replace(
        "{clientId}",
        clientId
      )}&type=${verticalId}`
    )
      .then((response) => {
        const {
          data: { data },
        } = response;
        const array = data.length ? data.map((item) => item.topic) : [];
        setUngroupedData(array);
        data.forEach((item, index) => {
          if (array[index].id == item.topic.id) {
            array[index]["feed_count"] = item.feed_count;
          }
        });
        const activeEntityId = getEntityId(array);
        setActiveAccordianKey(activeEntityId);
        getAllSocialFeeds(data, verticalId);
      })
      .catch((error) => {
        setHasData(false);
        setLoaderState(false);
        console.log(error);
      });
  };

  const getEntityId = (array, key) => {
    const currentTabKey = key ? key : selectedTabKey;
    const obj = array.filter((item) => item.category == currentTabKey)[0];
    return obj.id ? obj.id.toString() : "";
  };

  const showCount = (item) => {
    const data = tabData.find((i) => i.topic_category == item.toLowerCase());
    return data ? data["category_count"] : "";
  };

  const renderTabData = () => {
    const allArticleList =
      selectedFilter &&
      tabData.map(
        (e) =>
          `${SOCIAL_SOURCES.TWITTER}/${e.id}?entityName="${selectedFilter.label}"`
      );
    return TAB.map((item, idx) => {
      return (
        <Tab
          key={idx}
          eventKey={item.toLowerCase()}
          title={`${item}(${tabData.length})`}
        >
          {loaderState ? (
            <Loader />
          ) : (
            <>
              <div className="allFeedsAccordionWrap">
                {renderFeeds(
                  tabData,
                  selectedFilter.label,
                  allArticleList.flat()
                )}
                {/* <Accordion
                  defaultActiveKey={1}
                  onSelect={(e) =>
                    setActiveKeys((prevState) => {
                      return {
                        ...prevState,
                        [tabKey.toLowerCase()]: e ? e : "",
                      };
                    })
                  }
                ></Accordion>
                <React.Fragment key={idx}>{renderAccordian()}</React.Fragment> */}
              </div>
            </>
          )}
        </Tab>
      );
    });
  };

  const renderFeeds = (feedsList, entityName, allArticleList = []) => {
    if (feedsList && feedsList.length && !loaderState) {
      return (
        <React.Fragment key={selectedFeeds && selectedFeeds.length}>
          {feedsList.map((item, index) => {
            return (
              <SingleTwitterFeed
                key={item.id}
                entityName={entityName}
                selectedVertical={selectedVertical}
                isModal
                {...item}
                clientId={clientId}
                onFeedSelect={handleSingleFeedSelect}
                feedsToShare={selectedFeeds}
                allArticleList={allArticleList}
                selectedFilter={selectedFilter}
              />
            );
          })}
        </React.Fragment>
      );
    } else {
      return (
        <div className="noFilterDataWrap no-feeds">
          <NoFeedIcon size="sm" />
          <h6>No Feeds Found</h6>
        </div>
      );
    }
  };

  const renderAccordian = () => {
    const allArticleList =
      selectedFilter &&
      tabData.map(
        (e) =>
          `${SOCIAL_SOURCES.TWITTER}/${e.id}?entityName="${selectedFilter.label}"`
      );
    tabData.map((items, index) => {
      return (
        <Card
          key={index + 1}
          className={
            activeKeys[tabKey.toLowerCase()] == +(index + 1)
              ? "customAccordionRow feedAccordion active"
              : "customAccordionRow feedAccordion"
          }
        >
          <Sticky
            scrollElement=".allFeedsAccordionWrap"
            boundaryElement=".customAccordionRow"
            style={{ position: "relative" }}
            hideOnBoundaryHit={false}
          >
            <Card.Header>
              <label className="inputWrap">
                <input
                  type="checkbox"
                  onChange={() => handleTopicSelect(tabData)}
                  defaultChecked={isEntityGroupSelected(selectedFilter.label)}
                />
                <span className="checkmark"></span>
              </label>
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey={index + 1}
                onClick={() => accordianClick(tabData, index + 1)}
              >
                {selectedFilter.label} {`(${tabData.length || "0"})`}
              </Accordion.Toggle>
            </Card.Header>
          </Sticky>
          <Accordion.Collapse eventKey={index + 1}>
            <Card.Body>
              <>
                {renderFeeds(
                  tabData,
                  selectedFilter.label,
                  allArticleList.flat()
                )}
                {/* {tabData.length <  ? (
                <div className="viewMoreBtnWrap">
                  {feedLoader ? (
                    <Loader />
                  ) : (
                    <Button
                      className="btn btnBlue viewMoreBtn"
                      onClick={() => showMoreClick(topicData.id, topicData)}
                    >
                      View More
                    </Button>
                  )}
                </div>
              ) : null} */}
              </>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      );
    });
  };

  const showMoreClick = (entityId, { page, name }) => {
    setFeedLoader(true);
    setActiveAccordianKey(entityId);
    setCurrentPage(currentPage + 1);
    let today = getSocialApiDateFormat(new Date());
    httpGet(
      unifiedEnvConfig.FETCH_SOCIAL_DASHBOARD_FEEDS.replace("{page}", page + 1)
        .replace("{perPage}", perPage)
        .replace("{topic_id}", entityId)
        .replace("{type}", selectedVertical)
        .replace("{from_date}", today)
        .replace("{to_date}", today)
        .replace("{client_id}", clientId),
      {},
      true
    )
      .then((response) => {
        const {
          data: { data },
        } = response;
        const previousFeedArray = tabFeeds[tabKey].filter(
          (i) => i.id == entityId
        );
        let previousFeedsListForSelectedTopic = [];
        if (previousFeedArray && previousFeedArray.length) {
          previousFeedsListForSelectedTopic = previousFeedArray[0].feeds
            ? previousFeedArray[0].feeds
            : [];
        }
        if (isEntityGroupSelected(name)) {
          let tempSelectedFeedGroup = { ...selectedFeedGroup };
          const newSelectedFeedList = [...selectedFeedGroup[name], ...data];
          tempSelectedFeedGroup[name] = newSelectedFeedList;
          setSelectedFeedGroup(tempSelectedFeedGroup);
          setSelectedFeeds([...selectedFeeds, ...data]);
        }
        formatAndSetData({
          feed_list:
            previousFeedArray && previousFeedArray.length
              ? previousFeedArray
              : data,
          entity_list: [entityId],
          pagination: true,
          newFeeds: data,
          incrementPageCount: true,
        });
        setTabFeeds(tabFeeds);

        setFeedLoader(false);
      })
      .catch((error) => {
        setFeedLoader(false);
        setAllSocialFeeds([]);
        console.log(error);
      });
  };

  const getAllSocialFeeds = (entity_list = [], verticalId) => {
    if (entity_list.length > 0 && verticalId) {
      let today = getSocialApiDateFormat(new Date());
      setLoaderState(true);
      let url = `${unifiedEnvConfig.TWITTER_FEEDS}unifiedapi/social-feeds/top-retweets?topic_id=${topicId}&client_id=${clientId}&searchParams[from_date]=${startRange}&searchParams[to_date]=${endRange}`;
      const feedIdList = getEntityIdList(entity_list);
      feedIdList.forEach((t) => {
        url = `${url}&searchParams[topic_ids][]=${t}`;
      });
      httpGet(url, {}, true)
        .then((response) => {
          const {
            data: { data },
          } = response;
          const newDataList = formatAndSetData({
            feed_list: data,
            entity_list,
          });
          const formattedData = groupBy(newDataList, "category");
          setTabFeeds(formattedData);
          setLoaderState(false);
          setHasData(true);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const accordianClick = (id, key) => {
    setAllSocialFeeds([]);
    if (activeAccordian != id) {
      setCurrentPage(1);
      setActiveAccordian(id);
      setActiveAccordianKey(key);
    }
  };

  const tabClick = (tab) => {
    setTabKey(tab);
  };

  const verticalClick = (value) => {
    handleVerticalClick(value);
    setLoaderState(true);
    setTabFeeds([]);
    setHasData(false);
  };

  return (
    <Modal
      dialogClassName="customModal"
      className="allFeedsModal"
      show={show}
      onHide={() => onCancel(false)}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <span className="btnClose" onClick={() => onCancel(false)}>
          <ModalCloseIcon />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="modelHeader">
          <ButtonGroup
            className="smallToggleBtnGroup"
            onClick={(e) => verticalClick(e.target.value)}
          >
            <Button
              className={
                selectedVertical === TWITTER_INSIGHTS
                  ? "tagBlue active"
                  : "tagBlue"
              }
              value={TWITTER_INSIGHTS}
            >
              <TwitterWBIcon />
              X
            </Button>
          </ButtonGroup>
          <ShareArticle
            article={selectedFeeds}
            isSocial
            onShareSuccess={() => {
              setSelectedFeeds([]);
              setSelectedFeedGroup({});
            }}
          />
        </div>
        {loaderState ? (
          <Loader />
        ) : (
          <>
            {tabData ? (
              <>
                <Tabs
                  activeKey={tabKey}
                  transition={false}
                  onSelect={(tab) => tabClick(tab)}
                >
                  {renderTabData()}
                </Tabs>
                {renderAccordian()}
              </>
            ) : (
              <div className="noFilterDataWrap no-feeds">
                <NoFeedIcon size="sm" />
                <h6>No Feeds Found</h6>
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

TwitterFeedsModal.defaultProps = {
  show: false,
  onCancel: () => {},
  cancelButtonText: "Cancel",
};

export default TwitterFeedsModal;
